import { render } from "./Compliances.vue?vue&type=template&id=759509c4&scoped=true"
import script from "./Compliances.vue?vue&type=script&lang=js"
export * from "./Compliances.vue?vue&type=script&lang=js"

import "./Compliances.vue?vue&type=style&index=0&id=759509c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759509c4"]])

export default __exports__